import ApiClient from '../utils/apiClient';
import requestSuccessFailureHelper from '../utils/helpers/ReduxHelper';
import getVenueAreas from './venueAreasActions';
import setFilter from './filterActions';
import { filterConstants } from '../utils/types';
import {
  SINGLE_SESSION,
  UPCOMING_EVENTS,
  USER_BOOKED_EVENTS
} from '../utils/constants';

export function getUpcomingEvents(areaId = null) {
  const filterParam = areaId != null ? `?area=${areaId}` : '';
  const { action: getUpcomingEventsAction } = requestSuccessFailureHelper(
    UPCOMING_EVENTS,
    () => ApiClient.get(`/api/v1/upcoming-session-events/${filterParam}`)
  );

  return dispatch => {
    dispatch(getUpcomingEventsAction());
  };
}

export function getSession(id, areaId = null) {
  const filterParam = areaId != null ? `?area=${areaId}` : '';
  const { action: getSessionAction } = requestSuccessFailureHelper(
    SINGLE_SESSION,
    () => ApiClient.get(`/api/v1/sessions/${id}/${filterParam}`)
  );
  return dispatch => {
    dispatch(getSessionAction());
  };
}

export function getUserBookedSessionEvents() {
  const { action: userBookedSessionEventsAction } = requestSuccessFailureHelper(
    USER_BOOKED_EVENTS,
    () => ApiClient.get('/api/v1/user-bookings/')
  );
  return dispatch => {
    dispatch(userBookedSessionEventsAction());
  };
}

export function refreshSessions() {
  return dispatch => {
    dispatch(getUpcomingEvents());
    dispatch(getVenueAreas());
    dispatch(setFilter(filterConstants.AREA_FILTER, 0));
  };
}

export function refreshSession(sessionId) {
  return dispatch => {
    dispatch(getSession(sessionId));
    dispatch(getVenueAreas());
    dispatch(setFilter(filterConstants.AREA_FILTER, 0));
  };
}



// WEBPACK FOOTER //
// ./src/actions/sessionsActions.js